import { useStaticQuery, graphql } from 'gatsby';

export const useFooterNavElements = () => {
  const { contentfulFooterNav } = useStaticQuery(
    graphql`
      query {
        contentfulFooterNav {
          id
          footerNavTitle
          footerNavLogo {
            gatsbyImageData(width: 200)
            title
            description
          }
          footerNavGroups {
            id
            footerNavGroupTitle
            internalName
            links {
              icon
              iconSize
              classnameForAnalytics
              style
              actionEvent
              id
              label
              url
            }
          }
        }
      }
    `
  );
  return contentfulFooterNav;
};
